import { render, staticRenderFns } from "./DialogInvoice.vue?vue&type=template&id=516e99c7"
import script from "./DialogInvoice.vue?vue&type=script&lang=js"
export * from "./DialogInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports